import React from 'react';
import CloudinaryAdvancedImage from '@common/utils/CloudinaryAdvancedImage';

function Profile({imageUrl, name, designation}) {

  return (
    <div className='mod-profile'>
        <div className='mod-profile__image-wrap'>
          <CloudinaryAdvancedImage imagePublicId={imageUrl} altText={name} className='mod-profile__image' type="team-portrait" />
        </div>
        <h5 className='mod-profile__name'>{name}</h5>
        <p className='mod-profile__designantion'>{designation}</p>
    </div>
  )
}

export default Profile